import React, { useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardDescription,
} from "@/components/ui/card";
import { toast } from "@/components/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ActivationPage = () => {
  const [licenseKey, setLicenseKey] = useState("");
  const [ownerEmail, setOwnerEmail] = useState("");
  const [ownerPassword, setOwnerPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleActivate = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.activateLicense({
        licenseKey,
        ownerEmail,
        ownerPassword,
      });
      // auto login with provided credentials
      await login(ownerEmail, ownerPassword);
      navigate("/");
    } catch (e) {
      toast({
        title: t("activation.failedTitle"),
        description: t("activation.failedDesc"),
        variant: "destructive",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-blue-100 p-4">
      <Card className="w-full max-w-md shadow-lg">
        <CardHeader>
          <CardTitle>{t("activation.title")}</CardTitle>
          <CardDescription>
            {t("activation.description")}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleActivate} className="space-y-4">
            <div>
              <label className="text-sm font-medium">{t("activation.licenseKey")}</label>
              <Input
                value={licenseKey}
                onChange={(e) => setLicenseKey(e.target.value)}
                required
                placeholder={t("activation.licensePlaceholder")}
              />
            </div>
            <div>
              <label className="text-sm font-medium">{t("activation.ownerEmail")}</label>
              <Input
                type="email"
                value={ownerEmail}
                onChange={(e) => setOwnerEmail(e.target.value)}
                required
              />
            </div>
            <div>
              <label className="text-sm font-medium">{t("activation.ownerPassword")}</label>
              <Input
                type="password"
                value={ownerPassword}
                onChange={(e) => setOwnerPassword(e.target.value)}
                required
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? t("activation.activating") : t("activation.activate")}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default ActivationPage;
